// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"185":"4544409efbe34009","931":"75722366b59d7f57"}[chunkId] + ".css";
};